function isDesktop() {
    return typeof window !== "undefined" ? $(window).width() > 768 : false;
}

export default isDesktop;
